import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NoDataComponent implements OnInit {
  @Input() title: string = '';
  @Input() message: string = '';
  constructor() { }

  ngOnInit() { }

}
